import type { Ceviri } from "../tip";
import type { izleme as tr } from "../tr/izleme";

const cogul = (n: number, tekil: string, cok: string): string => (n === 1 ? tekil : cok);

/** English dictionary · izleme. */
export const izleme: Ceviri<typeof tr> = {
  ekran: {
    baslik: "Tracking",
    aciklama: "Where the centre stands for these instruments. The report produces no value for a period not yet filled.",
    sahteBaslik: "Fake centre",
    sahteOnce: "This run is not connected to the real centre (",
    sahteSonra: "). The states here are made up; not real data.",
    merkezYokBaslik: "Cannot reach the centre",
    merkezYokMetin:
      "Entering transactions, reading the vault and seeing positions do not depend on the centre — they keep working. This screen updates itself when the centre is back.",
    onbellekYokBaslik: "Price cache not connected",
    onbellekYokMetin: "Tracking status cannot be read.",
    hareketlerOkunamadi: "Transactions could not be read",
    hareketlerOkunuyor: "Reading transactions…",
    aracYokBaslik: "No tracked instruments",
    aracYokMetin:
      "When you link a transaction to an instrument tracked by the centre, the centre starts tracking it " +
      "and fills its ten-year history in the background. You will see its status here.",
    durumOkunamadi: "Tracking status could not be read",
    durumOkunuyor: "Reading tracking status…",
  },
  satir: {
    onbellekKaydiYok:
      "This device has no cache record for this instrument. When a sync runs, its status and prices come from the centre. (This does NOT mean the centre is not tracking it.)",
    paraBirimiBilinmiyor: "currency unknown",
    elleFiyatBaglanti: "Manual price",
    elleFiyatSonEk: "screen lets you enter a price for this instrument ID.",
    buCihazda: "On this device",
    fiyatYok: "no price",
    barSayisi: "Bars",
    merkezde: "At the centre",
    bilinmiyor: "unknown",
    sonEsitleme: "Last sync",
    hic: "never",
    sonHata: (hata) => `Last error: ${hata}`,
  },
  gecmis: {
    ufukBilinmiyor: "History horizon not known yet — set once the centre learns the instrument's issue date.",
    baslamadi: "History filling has not started yet",
    ufuk: (tarih) => ` (horizon: ${tarih})`,
    tam: (tarih) => `History complete back to ${tarih}.`,
    ilerlemeEtiketi: "History filling progress",
    kismi: (tarih, yuzde) => `Filled back to ${tarih} (${yuzde}). The report produces no value for earlier periods.`,
  },
  esitleme: {
    esitleniyor: "Syncing…",
    merkezdenEsitle: "Sync from centre",
    sonEsitleme: "Last sync",
    sonEsitlemeAn: (zaman, sebep) => `Last sync ${zaman} (${sebep})`,
    kurSatir: (n) => ` · exchange rate: ${n} rows written`,
    hatalar: (liste) => `Errors: ${liste}`,
    dahaFazla: (n) => ` and ${n} more`,
    ozet: (cagri, bar, ms) => `${cagri} ${cogul(cagri, "call", "calls")} · ${bar} bars written · ${ms} ms`,
    zatenGuncel: (n) => ` · ${n} ${cogul(n, "instrument", "instruments")} already up to date`,
    kaliciEksik: (liste) => `Permanently missing (not at the centre either, waiting will not fix it): ${liste}`,
    reddedildi: (n) => `${n} ${cogul(n, "bar", "bars")} rejected — bad format or out of range.`,
    fiyatHatasi: (mesaj) => `price: ${mesaj}`,
    kurHatasi: (mesaj) => `exchange rate: ${mesaj}`,
  },
  durum: {
    ufukHedef: "The horizon is at the ten-year target: nothing older is requested.",
    ufukIhrac:
      "The horizon starts at the instrument's issue date — there is no data before it because the instrument " +
      "did not exist yet. This is NOT a gap.",
    ufukKaynak:
      "The horizon is limited by the source's archive depth: prices existed in the market before this date " +
      "but the source does not provide them. This is a REAL gap and is flagged in the report.",
    ufukSebepsiz: "The centre did not say why the horizon is at that date; the horizon date is shown above.",
    gecmisKaynak: "History as far as the source provides",
    gecmis: "History",
    pendingBaslik: "Request received",
    pendingAnlam: (saniye) =>
      `The centre has started tracking this instrument but no price has arrived yet. The current price is usually ` +
      `ready within ${saniye} seconds; history follows.`,
    spotGunIciYokBaslik: "Latest published value ready",
    spotBaslik: "Current price ready",
    spotGunIciYokAnlam: (gecmis) =>
      "This asset class has no intraday price; the value is published once a day. " +
      "The latest published value we have is the current one; nothing fresher is published. " +
      `${gecmis} is filling in the background.`,
    spotAnlam: (gecmis) => `Current price and the last month of data are in. ${gecmis} is filling in the background.`,
    backfillingBaslik: "Preparing history",
    backfillingAnlam: (gecmis, ufuk) =>
      `${gecmis} is filling backwards from today. The report produces no value for periods not yet filled ` +
      `— a missing period is not counted as zero. ${ufuk}`,
    readyBaslik: "History complete",
    readyAnlam: (ufuk) =>
      `History from the horizon to today is complete. ${ufuk} ` + `Any known gaps are shown separately in the coverage details.`,
    dormantBaslik: "Refresh paused",
    dormantAnlam:
      "You no longer have open transactions in this instrument, so the centre paused refreshing it. Entering a new " +
      "transaction wakes it up again; the history you have was not deleted.",
    unresolvedBaslik: "Not resolved — you will enter the price",
    unresolvedAnlam:
      "No source could price this instrument; waiting will not fix it. To do: enter a price for this instrument ID " +
      "on the Manual price screen, or turn the transaction into a manually valued asset " +
      "and enter a value on the Manual valuation screen.",
  },
  eksikSebep: {
    no_cache: "not on this device at all — will be downloaded",
    before_cached: "before the start of the cache — will be downloaded",
    after_cached: "after the end of the cache — will be downloaded",
    interior_gap: "gap in between — will be downloaded",
    known_gap: "not at the centre either — waiting will not fix it",
    outside_central: "outside the centre's coverage — no point requesting",
  },
  elleFiyat: {
    baslik: "Manual price",
    aciklama: "End-of-day close for instruments without a central price source.",
    asama2Baslik: "What changes in stage 2",
    asama2Once: "Prices of tracked instruments will come from the centre. This screen will remain for instruments no source can resolve (",
    asama2Sonra: ").",
    kimlikleListele: "List by instrument ID",
    listele: "List",
    kimlikGirin: "Enter an instrument ID",
    kimlikGirinMetin: "Saved prices for that instrument are listed.",
    kayitYok: "No price records for this instrument",
    tabloBasligi: (ref) => `Manual prices for ${ref}`,
    tarih: "Date",
    kapanis: "Close",
    paraBirimi: "Currency",
    kimlikZorunlu: "Instrument ID is required.",
    tarihZorunlu: "Date is required.",
    paraBirimiSecin: "Choose a currency from the list.",
    izlenenArac:
      "This instrument is tracked: its daily price comes from the source and is unique. " +
      "Manual prices are only for untracked (manually valued) assets.",
    formEtiketi: "Manual price entry",
    fiyatKaydet: "Save price",
    aracKimligi: "Instrument ID",
    tekrarKayit: "Saving again for the same instrument and date replaces the existing value.",
  },
  elleDeger: {
    baslik: "Manual valuation",
    aciklama: "The value on a given date of assets without a central price source.",
    yukleniyor: "Loading valuations…",
    kayitYok: "No manual valuation records",
    kayitYokMetin: "The label must be written exactly like the 'manually valued asset' label in transactions to match.",
    tabloBasligi: "Manual valuation records",
    etiket: "Label",
    tarih: "Date",
    deger: "Value",
    not: "Note",
    islem: "Action",
    silOnayBaslik: "Delete valuation?",
    silOnaySonEk: "record will be removed from the list (tombstone).",
    etiketZorunlu: "Label is required.",
    formEtiketi: "Manual valuation entry",
    degerlemeKaydet: "Save valuation",
    varlikEtiketi: "Asset label",
    etiketIpucu: "Must match the label in transactions exactly.",
    etiketOrnek: "Physical gold (grams)",
    degerlemeTarihi: "Valuation date",
    paraBirimi: "Currency",
    notIpucu: "Source of the value (jeweller's buy price, last trade price…).",
  },
  arama: {
    devreDisi: "Search disabled",
    merkezeUlasilamiyor: "Cannot reach the centre.",
    devreDisiMetin:
      "You can type the instrument ID below or save the asset as a manually valued asset — entering transactions does not depend on the centre.",
    yerTutucu: "THYAO, Turkish Airlines, ISIN…",
    enAz: (n) => `Type at least ${n} characters to search.`,
    araniyor: "Searching the centre…",
    ulasilamadiNokta: "Could not reach the centre.",
    sorulamadiBos: 'The external source could not be queried right now — this does not mean "no instrument".',
    sorulamadiAdaylar: (n) =>
      `${n} ${cogul(n, "candidate", "candidates")} found, but the external source could not be queried right now; the list may be incomplete.`,
    eslesmeYok: "No matching instrument found.",
    adaylar: (n) => `${n} ${cogul(n, "candidate", "candidates")} found; choose from the list.`,
    sorulamadiBaslik: "External source could not be queried right now",
    sorulamadiMetin:
      "The centre did not recognise this code in its own catalogue and could not query the equity/ETF source (Yahoo) right now — rate limit or source error. Search again in a minute; try this before saving the instrument as a manually valued asset.",
    ulasilamadi: "Could not reach the centre",
    calismiyor:
      "Search is not working right now. You can still save the transaction: type the ID yourself or switch to a manually valued asset.",
    birdenFazlaOnce: "There is more than one candidate; ",
    birdenFazlaSiz: "you",
    birdenFazlaSonra: " choose the right one. A transaction linked to the wrong instrument is the hardest error to notice later.",
    adaylarEtiketi: "Instrument candidates",
    paraBirimi: (ad) => `Currency: ${ad}`,
    eslesmeGuveni: (yuzde) => `Match confidence: ${yuzde}`,
    izlenmiyor: "not tracked yet",
    merkezIzliyor: "tracked by the centre",
    katalogTazeligi: (an) => `Catalogue freshness: ${an}`,
    bulamadim: "Not found — save as a manually valued asset",
  },
  baglama: {
    varlik: "Asset",
    tur: "Link type",
    turIzlenen: "Tracked instrument (priced by the centre)",
    turElle: "Manually valued asset",
    aracAra: "Search instrument",
    aracAraIpucu: "Search the centre's catalogue and choose the right one from the candidates.",
    paraBirimiOnEk: " · Currency: ",
    baskaArac: "Choose another instrument",
    izlemeyeAliniyor: "Starting to track the instrument…",
    cozulemediBaslik: "This instrument could not be resolved — manual valuation needed",
    elleyeCevir: "Turn into a manually valued asset",
    ilerlemeOnce: "You can follow progress on the ",
    ilerlemeEkran: "Tracking",
    ilerlemeSonra: " screen.",
    alinamadiBaslik: "Could not start tracking",
    alinamadiMetin:
      "You can still save the transaction — the vault does not depend on the centre. The instrument can be put under tracking from the Tracking screen once the centre is reachable.",
    merkezsizDevam: "Continue without the centre: type the instrument ID",
    aracKimligi: "Instrument ID",
    aracKimligiIpucu: "The centre's canonical ID (e.g. BIST:THYAO). A wrong ID means a wrong price.",
    varlikEtiketi: "Asset label",
    etiketIpucu: "The manual valuation screen matches on this label.",
    etiketOrnek: "Physical gold (grams)",
    varlikParaBirimi: "Asset currency",
    paraBirimiBilinmiyor: "The centre does not know this asset's currency — choose from the list.",
  },
};
